import type { NavigationGuard, Router } from "vue-router";

export interface HostRouterBridge {
  mode: "history" | "hash";
  base: string;
  beforeHooks: NavigationGuard[];
  afterHooks: Array<(to: unknown, from: unknown) => void>;
  push: Router["push"];
  replace: Router["replace"];
  currentRoute: Router["currentRoute"];
}

/**
 * The `hostRouter` mount arg of the legacy AppMount contract. Remotes read
 * mode/base/beforeHooks to configure the router their bootloader creates
 * (that createRouter() is intercepted by the legacy router bridge, so the
 * values only matter for the guard fallback) and call push() to navigate to
 * host-owned routes. beforeHooks stays empty so each remote installs its own
 * authorizationGuard, scoped to its prefixes by the bridge.
 */
export function createHostRouterBridge(router: Router, basePath = "/"): HostRouterBridge {
  return {
    mode: "history",
    base: basePath,
    beforeHooks: [],
    afterHooks: [],
    push: router.push.bind(router),
    replace: router.replace.bind(router),
    currentRoute: router.currentRoute,
  };
}
